<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-cash-register">{{
              $t("homeMenuCartInfoCashierTitle")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0 animated fadeIn">
            <v-card
              class="pt-2 pb-2 mb-12"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-text class="my-0 py-0 px-2">
                <div
                  style="background-color: #fcfcfc; border: 1px solid gainsboro"
                  class="ma-0"
                >
                  <v-select
                    class="pa-4 ma-0"
                    style="height: 74px"
                    item-text="name"
                    item-value="name"
                    :items="$store.state.storeDelivery.delivery"
                    :label="$t('userCashierDeliveryTitle')"
                    v-model="deliveryName"
                    @change="setNewDelivery(deliveryName)"
                    dense
                    outlined
                  >
                    <template slot="item" slot-scope="data">
                      <!-- for Vuetify 2.6+ replace slot="item" slot-scope="data" by v-slot:item="data" -->
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.name }}
                    </template>
                  </v-select>
                  <!-- NAČIN PLAČILA -->
                  <div
                    class="px-4 py-0 pb-1 ma-0"
                    v-if="deliveryName.length > 0"
                  >
                    <v-select
                      style="height: 58px"
                      item-text="title"
                      item-value="type"
                      :items="deliveryTypeItemsSelect"
                      :label="$t('userCashierDeliveryTypeTitle')"
                      v-model="deliveryType"
                      @change="adjustExtraCharge(deliveryType)"
                      dense
                      outlined
                    >
                      <template slot="item" slot-scope="data">
                        <!-- for Vuetify 2.6+ replace slot="item" slot-scope="data" by v-slot:item="data" -->
                        <!-- HTML that describe how select should render items when the select is open -->
                        {{ data.item.title }}
                      </template>
                    </v-select>
                  </div>
                </div>
                <div v-if="deliveryName.length > 0 && deliveryType.length > 0">
                  <div
                    class="mb-3 px-2 py-1 warning white--text"
                    v-if="deliveryType == 'prepay'"
                  >
                    <v-icon small color="white" class="pr-1">mdi-alert</v-icon>
                    {{ $t("userCashierDeliveryTypePrepayInfoTitle") }}
                  </div>
                  <div
                    class="mb-3 px-2 py-1 warning white--text"
                    v-else-if="deliveryType == 'atDelivery'"
                  >
                    <v-icon small color="white" class="pr-1">mdi-alert</v-icon>
                    {{ $t("userCashierDeliveryTypeAtDeliveryInfoTitle") }}
                  </div>
                  <!-- Napis za dodatni popust, če naročijo več... -->
                  <div
                    class="px-4 pb-1"
                    v-if="
                      (deliveryName.length > 0 &&
                        this.$store.state.storeCart.totalSumCart <
                          deliverySelected.extraChargeFreeOver &&
                        deliverySelected.extraCharge > 0) ||
                      (this.deliveryName.length > 0 &&
                        this.deliverySelected.extraChargeFreeOver == 0 &&
                        this.deliverySelected.extraCharge > 0)
                    "
                  >
                    <div class="pb-0 ma-0 mt-3">
                      {{ $t("userNewOrderSummary6Title") }}:
                      {{ price(this.$store.state.storeCart.totalSumCart) }}
                    </div>
                    <div class="pb-2 ma-0">
                      {{ deliverySelected.extraChargeMessage }}:
                      {{ price(deliverySelected.extraCharge) }}
                    </div>
                    <v-card
                      v-if="this.deliverySelected.extraChargeFreeOver > 0"
                      class="ma-0 mb-3 pa-0"
                      color="accent"
                      dark
                      flat
                    >
                      <v-card-text class="ma-0 px-2 py-1">
                        <div>
                          <v-icon small class="pr-1 white--text"
                            >mdi-sale</v-icon
                          >
                          {{ $t("userCashierAddMore1Title") }}
                          <strong>
                            {{
                              price(
                                parseFloat(
                                  deliverySelected.extraChargeFreeOver
                                ) - this.$store.state.storeCart.totalSumCart
                              )
                            }}
                          </strong>
                          {{ $t("userCashierAddMore2Title") }}
                          <strong>{{
                            price(deliverySelected.extraCharge)
                          }}</strong>
                          ({{ deliverySelected.extraChargeMessage }}).
                        </div>
                      </v-card-text>
                    </v-card>
                    <div
                      class="d-flex"
                      v-if="this.deliverySelected.extraChargeFreeOver > 0"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        outlined
                        class="mt-0 mb-2"
                        to="/"
                        >{{ $t("userCashierAddItemsTitle") }}</v-btn
                      >
                      <v-spacer></v-spacer>
                    </div>
                  </div>
                  <!-- glavni podatek "Za plačilo" -->
                  <div
                    class="
                      subtitle-1
                      font-weight-regular
                      px-4
                      py-2
                      white--text
                      error
                    "
                  >
                    {{ $t("userCashierFinalSumTitle") }}:
                    <strong>{{ price(deliveryFinalSum) }}</strong>
                  </div>

                  <!-- prikaz napake, če je znesek null ali 0 -->
                  <div
                    v-if="finalSumNull"
                    class="
                      subtitle-1
                      font-weight-regular
                      px-4
                      py-2
                      white--text
                      error
                    "
                  >
                    {{ $t("userCashierFinalSumNullTitle") }}:
                  </div>

                  <div
                    class="mx-2 mt-1 caption"
                    v-if="
                      Number(
                        $store.state.storeClient.client.environmentSettings
                          .taxTitle
                      ) > 0
                    "
                  >
                    {{ $t("userOrdersIncludesTax") }}
                    {{
                      $store.state.storeClient.client.environmentSettings
                        .taxTitle
                    }}.
                  </div>

                  <!-- Prikažemo osebne podatke -->
                  <div
                    v-if="deliveryName.length > 0"
                    class="my-4 pb-4 px-4"
                    style="
                      background-color: #fcfcfc;
                      border: 1px solid gainsboro;
                    "
                  >
                    <!-- če kateri podatek manjka, prikažemo urejanje podatkov -->
                    <div
                      v-if="addUserInfo"
                      class="d-flex flex-no-wrap justify-space-between pa-0"
                    >
                      <v-flex xs12>
                        <div
                          v-if="
                            (addressItem.isCompany &&
                              addressItem.vatNumber.length < 2) ||
                            addressItem.country.length < 2 ||
                            addressItem.address2.length < 2 ||
                            addressItem.address1.length < 2 ||
                            addressItem.fullName.length < 2 ||
                            addressItem.phone.length < 2 ||
                            addressItem.email.length < 2
                          "
                          class="my-4 px-2 py-1 warning white--text"
                        >
                          <v-icon small color="white" class="pr-1"
                            >mdi-alert</v-icon
                          >
                          {{ $t("userCashierEditUserProfileTitle") }}
                        </div>
                        <v-text-field
                          v-if="addressItem.isCompany"
                          v-model="addressItem.vatNumber"
                          style="height: 40px"
                          outlined
                          class="pa-0 ma-0 mt-5"
                          dense
                          :label="$t('userSettingsVatNumberTitle')"
                          :rules="[validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                        <v-text-field
                          v-model="addressItem.fullName"
                          style="height: 40px"
                          outlined
                          class="pa-0 ma-0 mt-5"
                          dense
                          :label="
                            addressItem.isCompany
                              ? $t('userSettingsCompanyFullNameTitle')
                              : $t('userSettingsFullNameTitle')
                          "
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                        <v-text-field
                          v-model="addressItem.address1"
                          style="height: 40px"
                          outlined
                          class="pa-0 ma-0 mt-5"
                          dense
                          :label="
                            addressItem.isCompany
                              ? $t('userSettingsCompanyAddress1Title')
                              : $t('userSettingsAddress1Title')
                          "
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                        <v-text-field
                          v-model="addressItem.address2"
                          style="height: 40px"
                          outlined
                          class="pa-0 ma-0 mt-5"
                          dense
                          :label="$t('userSettingsAddress2Title')"
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                        <v-select
                          item-text="title"
                          item-value="cShort"
                          class="pa-0 ma-0 mt-5"
                          style="height: 40px"
                          dense
                          outlined
                          :items="countryItems"
                          v-model="addressItem.country"
                          :label="$t('userSettingsCountryTitle')"
                          :rules="[validateRequired()]"
                        ></v-select>
                        <v-text-field
                          v-model="addressItem.phone"
                          style="height: 40px"
                          outlined
                          class="pa-0 ma-0 mt-5"
                          dense
                          :label="$t('userSettingsPhoneTitle')"
                          :rules="[validateRequired(), validateMaxLength(50)]"
                          :counter="50"
                        ></v-text-field>
                        <v-text-field
                          v-model="addressItem.email"
                          style="height: 40px"
                          outlined
                          class="pa-0 ma-0 mt-5"
                          dense
                          :label="$t('userSettingsEmailTitle')"
                          :rules="[
                            validateRequired(),
                            validateIsEmail(),
                            validateMaxLength(100),
                          ]"
                          :counter="100"
                        ></v-text-field>
                      </v-flex>
                    </div>
                    <div v-else>
                      <div class="subtitle-2 mt-4 mb-2">
                        {{ $t("userCashierAddressAndPhoneDataTitle") }}
                        <v-icon
                          @click="addUserInfo = true"
                          medium
                          color="secondary"
                          >mdi-account-edit</v-icon
                        >
                      </div>
                      <div class="ml-2">
                        <div v-if="addressItem.isCompany">
                          <v-icon small class="mr-2">mdi-numeric</v-icon>
                          {{ addressItem.vatNumber }}
                        </div>
                        <div>
                          <v-icon small class="mr-2">mdi-face</v-icon>
                          {{ addressItem.fullName }}
                        </div>
                        <div>
                          <v-icon small class="mr-2">mdi-home</v-icon>
                          {{ addressItem.address1 }}
                        </div>
                        <div>
                          <v-icon small class="mr-2">mdi-city</v-icon>
                          {{ addressItem.address2 }}
                        </div>
                        <div>
                          <v-icon small class="mr-2">mdi-flag</v-icon>
                          {{
                            countryItems.find(
                              (x) => x.cShort == addressItem.country
                            ).title
                          }}
                        </div>
                        <div>
                          <v-icon small class="mr-2">mdi-cellphone</v-icon>
                          {{ addressItem.phone }}
                        </div>
                        <div>
                          <v-icon small class="mr-2">mdi-at</v-icon>
                          {{ addressItem.email }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Sporočilo studiu -->
                  <v-text-field
                    v-model="messageForStudio"
                    style="height: 40px"
                    outlined
                    class="pa-0 ma-0 mt-4"
                    dense
                    :label="$t('userNewOrderSummaryStudioInfoTitle')"
                  ></v-text-field>

                  <!-- Potrditev zaključka -->
                  <div
                    v-if="
                      (addressItem.isCompany &&
                        addressItem.vatNumber.length < 2) ||
                      addressItem.country.length < 2 ||
                      addressItem.address2.length < 2 ||
                      addressItem.address1.length < 2 ||
                      addressItem.fullName.length < 2 ||
                      addressItem.phone.length < 2 ||
                      addressItem.email.length < 2 ||
                      finalSumNull
                    "
                  >
                    <div class="d-flex">
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" disabled class="mt-5 mb-5">
                        <v-icon class="mr-2">mdi-cloud-upload</v-icon>
                        {{ $t("userCashierFinishOrderTitle") }}
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </div>
                  <div v-else>
                    <v-dialog v-model="dialog" persistent max-width="400">
                      <template v-slot:activator="{ on }">
                        <div class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" class="mt-5 mb-5" v-on="on">
                            <v-icon class="mr-2">mdi-cloud-upload</v-icon>
                            {{ $t("userCashierFinishOrderTitle") }}
                          </v-btn>
                          <v-spacer></v-spacer>
                        </div>
                      </template>
                      <v-card>
                        <v-card-title class="headline">
                          <span v-if="!dialogWait">{{ $t("msgConfirm") }}</span>
                          <span v-else>{{
                            $t("userNewOrderPleaseWaitTitle")
                          }}</span>
                        </v-card-title>
                        <v-card-text v-if="!dialogWait">{{
                          $t("userCashierMsgConfirm")
                        }}</v-card-text>
                        <v-card-text class="d-flex" v-else>
                          <v-spacer></v-spacer>
                          <v-progress-linear
                            color="primary"
                            height="10"
                            indeterminate
                          ></v-progress-linear>
                          <v-spacer></v-spacer>
                        </v-card-text>
                        <v-card-actions v-if="!dialogWait">
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="dialog = false">{{
                            $t("lmBtnBack")
                          }}</v-btn>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" text @click="addOrder()">{{
                            $t("lmBtnConfirm")
                          }}</v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'userCart' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import { makeId, convertQR } from "@/mixins/utils";
import QRCode from "qrcode";

import {
  G_MODULE_PHOTO_ORDER,
  G_MODULE_PHOTO_GIFT,
  G_MODULE_ALL,
} from "@/constants";
import firebase from "firebase/app"; // za servertimestamp

export default {
  name: "userCashier",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
  data() {
    return {
      strQR: "",
      referenceId: "", // UPN referenca
      addUserInfo: false,
      dialog: false,
      dialogWait: false,
      deliveryName: "",
      deliveryType: "",
      deliverySelected: {},
      deliveryExtraChargeInfo: 0,
      deliveryFinalSum: 0,
      messageForStudio: "",
      deliveryTypeItemsSelect: [],
      addressItem: {
        isCompany: this.$store.state.storeAuth.userProfile.isCompany,
        vatNumber: this.$store.state.storeAuth.userProfile.vatNumber,
        fullName: this.$store.state.storeAuth.userProfile.fullName,
        address1: this.$store.state.storeAuth.userProfile.address1,
        address2: this.$store.state.storeAuth.userProfile.address2,
        country: this.$store.state.storeAuth.userProfile.country,
        phone: this.$store.state.storeAuth.userProfile.phone,
        email: this.$store.state.storeAuth.userProfile.email,
      },
      netBackImage: require("@/assets/netBack.png"),
      finalSumNull: false,
    };
  },
  methods: {
    async addOrder() {
      this.dialogWait = true;
      try {
        // če smo morali urediti še osebne podatke, jih zdaj shranimo
        if (this.addUserInfo)
          this.$store.dispatch("saveUserSettings", this.addressItem);

        // pridobimo naslednji orderId
        await this.$store
          .dispatch("getClientNextOrderId", {
            client: this.$store.state.storeClient.client.basicSettings.name,
          })
          .catch((error) => {
            console.log(error);
            return error;
          });

        // dodamo vrednost naročila v uporabnikovo statistitko in preberemo v spremenljivko, da lahko dodamo direktni info v naročilo
        const orderUsersStats = await this.$store.dispatch("setUserStats", {
          uid: this.$store.state.storeAuth.user.uid,
          client: this.$store.state.storeClient.client.basicSettings.name,
          email: this.$store.state.storeClient.client.basicSettings.email,
          orders: 1,
          ordersSum: this.deliveryFinalSum,
        });

        console.log(
          "checkNumOfCartItems",
          this.$store.state.storeCart.cart.length
        );

        if (
          this.$store.state.storeCart.cart.length == 0 ||
          this.$store.state.storeCart.cart == undefined
        )
          this.$store.dispatch("addError", {
            code: 1004,
            client: this.$store.state.storeClient.client.basicSettings.name,
            debugInfo: {
              appVersion:
                this.$store.getters.appVersion !== undefined
                  ? this.$store.getters.appVersion
                  : "",
              appOS:
                this.$store.state.os !== undefined ? this.$store.state.os : "",
              appBrowser:
                this.$store.state.browser !== undefined
                  ? this.$store.state.browser
                  : "",
              appMemory:
                this.$store.state.memory !== undefined
                  ? String(this.$store.state.memory)
                  : "",
            },
            details: "",
            email: this.$store.state.storeAuth.user.email,
            errorObj: "addOrder",
            file: "UserCashier.vue",
            function: "addOrder",
            generated: "Empty cart on addOrder",
            simpleUpload: false,
            str: "Empty cart on addOrder",
            timestamp: new Date(),
          });

        // dodamo nov order v bazo
        await this.$store
          .dispatch("addOrder", {
            orders: orderUsersStats.orders,
            ordersSum: orderUsersStats.ordersSum,
            client: this.$store.state.storeClient.client.basicSettings.name,
            orderId: this.$store.state.storeClientCounters.orderId,
            clientFullName:
              this.$store.state.storeClient.client.basicSettings.fullName,
            logoLink:
              this.$store.state.storeClient.client.loginSettings.logoLink,
            qrCode: this.strQR,
            qrCodeReference: this.referenceId,
            sendEmailSubject: this.generateNewOrderEmailSubject("full"), // subject za pošiljanje emaila
            sendEmailSubjectNotify: this.generateNewOrderEmailSubject("notify"), // subject za pošiljanje emaila brez cene
            sendEmailHtml: this.generateNewOrderEmailBody(), // html za pošiljanje emaila
            sendEmailHtmlNotifyPhotoOrder:
              this.generateNewOrderEmailBodyNotify(G_MODULE_PHOTO_ORDER), // html za pošiljanje delnega emaila o naročilu
            sendEmailHtmlNotifyPhotoGift:
              this.generateNewOrderEmailBodyNotify(G_MODULE_PHOTO_GIFT), // html za pošiljanje delnega emaila o naročilu
            sendOrderCompleteEmailSubject:
              this.generateOrderCompleteEmailSubject(), // subject za pošiljanje emaila o zaključenem naročilu
            sendOrderCompleteEmailHtml: this.generateOrderCompleteEmailBody(), // html za pošiljanje emaila o zaključenem naročilu
            modulePhotoGiftNotifyEmail:
              this.$store.state.storeClient.client.modules.modulePhotoGift
                .notifyEmail,
            modulePhotoOrderNotifyEmail:
              this.$store.state.storeClient.client.modules.modulePhotoOrder
                .notifyEmail,
            uid: this.$store.state.storeAuth.user.uid,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            status: 0,
            hasFiles: true, // da se zagotovo doda, ga dodamo tudi v cloud funkcijah (other.js => exports.addToOrder)
            isCompany: this.$store.state.storeAuth.userProfile.isCompany,
            vatNumber: this.$store.state.storeAuth.userProfile.vatNumber,
            fullName: this.$store.state.storeAuth.userProfile.fullName,
            address1: this.$store.state.storeAuth.userProfile.address1,
            address2: this.$store.state.storeAuth.userProfile.address2,
            country: this.countryItems.find(
              (x) => x.cShort == this.$store.state.storeAuth.userProfile.country
            ).title,
            phone: this.$store.state.storeAuth.userProfile.phone,
            email: this.$store.state.storeAuth.userProfile.email,
            messageForStudio: this.messageForStudio,
            deliveryName: this.deliveryName,
            deliveryType: this.deliveryType,
            deliveryTypeString: this.deliveryTypeItems.find(
              (x) => x.type == this.deliveryType
            ).title,
            deliveryExtraChargeMessage:
              this.deliverySelected.extraChargeMessage,
            deliveryExtraChargeInfo: this.deliveryExtraChargeInfo,
            deliveryShowAddress: this.deliverySelected.showAddress,
            deliveryFinalSum: this.deliveryFinalSum,
            storeCart: this.$store.state.storeCart,
            currency:
              this.$store.state.storeClient.client.environmentSettings.currency,
            modulePhotoOrderExtraChargeMessage:
              this.$store.state.storeClient.client.modules.modulePhotoOrder
                .extraChargeMessage,
            modulePhotoOrderExtraCharge:
              this.$store.state.storeClient.client.modules.modulePhotoOrder
                .extraCharge,
            modulePhotoGiftExtraChargeMessage:
              this.$store.state.storeClient.client.modules.modulePhotoGift
                .extraChargeMessage,
            modulePhotoGiftExtraCharge:
              this.$store.state.storeClient.client.modules.modulePhotoGift
                .extraCharge,
            debugInfo: {
              appVersion:
                this.$store.getters.appVersion !== undefined
                  ? this.$store.getters.appVersion
                  : "",
              appOS:
                this.$store.state.os !== undefined ? this.$store.state.os : "",
              appBrowser:
                this.$store.state.browser !== undefined
                  ? this.$store.state.browser
                  : "",
              appMemory:
                this.$store.state.memory !== undefined
                  ? String(this.$store.state.memory)
                  : "",
            },
          })
          .then(() => {
            // če je bila koda aktivirana in je enkratna, jo dodamo v bazo aktiviranih kod, da preprečimo ponovno uporabo
            if (
              !this.$store.state.storeCart.activePromoCodePermanent &&
              this.$store.state.storeCart.activePromoCodeActivated
            ) {
              this.$store.dispatch("addPromoCodeUsed", {
                client: this.$store.state.storeClient.client.basicSettings.name,
                uid: this.$store.state.storeAuth.user.uid,
                promoCodeId: this.$store.state.storeCart.activePromoCodeId,
              });
            }
            this.dialog = false;
            this.$router.push({ name: "userOrders" });
          })
          .catch((error) => {
            console.log(error);
            return error;
          });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    async adjustExtraCharge(name) {
      console.log(name);
      // napaka, če je končni znesek nedefiniran ali 0
      if (
        this.deliveryFinalSum === undefined ||
        parseFloat(this.deliveryFinalSum <= 0)
      ) {
        this.finalSumNull = true;
      }
      // če je potrebno, kreiramo QRkodo, glede na državo
      if (
        name == "prepay" &&
        this.$store.state.storeClient.client.prepaySettings.enableQRCode
      ) {
        if (
          this.$store.state.storeClient.client.prepaySettings.qrCodeFormat ==
          "sl"
        ) {
          let tSum = (parseFloat(this.deliveryFinalSum) * 100).toFixed(0);
          tSum = tSum.toString().padStart(11, "0");

          this.referenceId = "SI00" + makeId(6, 1); // referenco najprej shranimo brez presledkov za qr kodo

          let controlNum =
            5 +
            Number(
              convertQR(this.addressItem.fullName).trim().substring(0, 33)
                .length
            ) +
            Number(
              convertQR(this.addressItem.address1).trim().substring(0, 33)
                .length
            ) +
            Number(
              convertQR(this.addressItem.address1).trim().substring(0, 33)
                .length
            ) +
            Number(tSum.toString().trim().length) +
            4 +
            Number(
              convertQR(this.$t("userCashierQRCodePayment"))
                .trim()
                .substring(0, 42).length
            ) +
            Number(
              this.$store.state.storeClient.client.prepaySettings.qrCompanyAccount
                .trim()
                .substring(0, 34).length
            ) +
            Number(this.referenceId.trim().substring(0, 26).length) +
            Number(
              convertQR(
                this.$store.state.storeClient.client.prepaySettings
                  .qrCompanyTitle
              )
                .trim()
                .substring(0, 33).length
            ) +
            Number(
              convertQR(
                this.$store.state.storeClient.client.prepaySettings
                  .qrCompanyAddress1
              )
                .trim()
                .substring(0, 33).length
            ) +
            Number(
              convertQR(
                this.$store.state.storeClient.client.prepaySettings
                  .qrCompanyAddress2
              )
                .trim()
                .substring(0, 33).length
            );

          let controlNumStr = String(controlNum + 17);

          if (controlNumStr.length <= 2) {
            controlNumStr = "0" + controlNumStr;
          }

          let inputStr =
            "UPNQR\n" +
            "\n" +
            "\n" +
            "\n" +
            "\n" +
            convertQR(this.addressItem.fullName).trim().substring(0, 33) +
            "\n" +
            convertQR(this.addressItem.address1).trim().substring(0, 33) +
            "\n" +
            convertQR(this.addressItem.address2).trim().substring(0, 33) +
            "\n" +
            tSum.toString().trim() +
            "\n\n\nADVA\n" +
            convertQR(this.$t("userCashierQRCodePayment"))
              .substring(0, 42)
              .trim() +
            "\n\n" +
            convertQR(
              this.$store.state.storeClient.client.prepaySettings
                .qrCompanyAccount
            )
              .trim()
              .substring(0, 34) +
            "\n" +
            this.referenceId.trim().substring(0, 26) +
            "\n" +
            convertQR(
              this.$store.state.storeClient.client.prepaySettings.qrCompanyTitle
            )
              .trim()
              .substring(0, 33) +
            "\n" +
            convertQR(
              this.$store.state.storeClient.client.prepaySettings
                .qrCompanyAddress1
            )
              .trim()
              .substring(0, 33) +
            "\n" +
            convertQR(
              this.$store.state.storeClient.client.prepaySettings
                .qrCompanyAddress2
            )
              .trim()
              .substring(0, 33) +
            "\n" +
            controlNumStr +
            "\n";

          let segs = [
            {
              data: inputStr,
              mode: "byte",
            },
          ];

          if (name == "prepay") {
            this.strQR = await QRCode.toDataURL(segs, {
              version: 15,
              errorCorrectionLevel: "M",
            });
            this.referenceId =
              this.referenceId.substr(0, 4) + " " + this.referenceId.substr(4); // na koncu vrinemo en presledek, za lažjo berljivost za uporabnika
          } else this.strQR = "";

          // console.log(inputStr);
        } else {
          this.strQR = "";
          this.referenceId = "";
        }
      }
    },
    setNewDelivery(name) {
      this.deliveryFinalSum = this.$store.state.storeCart.totalSumCart;

      this.deliverySelected = this.$store.state.storeDelivery.delivery.find(
        (item) => item.name == name
      );
      // pretvorimo v številke, za vsak slučaj
      this.deliverySelected.extraCharge = Number(
        this.deliverySelected.extraCharge
      );
      this.deliverySelected.extraChargeFreeOver = Number(
        this.deliverySelected.extraChargeFreeOver
      );

      // dodamo načine plačila, ki so pripeti vsaki poslovni enoti različno
      this.deliveryTypeItemsSelect = this.deliveryTypeItems.filter((x) =>
        this.deliverySelected.selectedPaymentTypes.includes(x.type)
      );
      this.deliveryType = "";

      this.deliveryExtraChargeInfo = 0; // samo za info, da damo v order podatek
      if (
        (this.deliveryName.length > 0 &&
          this.$store.state.storeCart.totalSumCart <
            this.deliverySelected.extraChargeFreeOver &&
          this.deliverySelected.extraCharge > 0) ||
        (this.deliveryName.length > 0 &&
          this.deliverySelected.extraChargeFreeOver == 0 &&
          this.deliverySelected.extraCharge > 0)
      ) {
        this.deliveryFinalSum =
          this.$store.state.storeCart.totalSumCart +
          parseFloat(this.deliverySelected.extraCharge);
        this.deliveryExtraChargeInfo = parseFloat(
          this.deliverySelected.extraCharge
        );
      }
    },
    generateNewOrderEmailSubject(mode) {
      return (
        this.$t("userOrdersSendEmailSubject") +
        ": " +
        this.$store.state.storeClientCounters.orderId +
        (mode == "full" ? " (" + this.price(this.deliveryFinalSum) + ")" : "")
      );
    },
    generateOrderCompleteEmailSubject() {
      return (
        this.$t("userOrdersCompleteSendEmailSubject") +
        ": " +
        this.$store.state.storeClientCounters.orderId +
        " " +
        this.$t("userOrdersCompleteSendEmailSubject2")
      );
    },
    generateOrderCompleteEmailBody() {
      let tempDelivery =
        this.$store.state.storeClient.client.responseSettings.orderCompletedPersonal
          .split("[personal]")
          .join(this.deliveryName);

      let body = "";
      body +=
        "<h2>" +
        this.$t("userCashierOrderIdTitle") +
        ": " +
        this.$store.state.storeClientCounters.orderId +
        "</h2>";
      body += this.deliverySelected.showAddress
        ? this.$store.state.storeClient.client.responseSettings
            .orderCompletedPost
        : tempDelivery;

      body +=
        "<p><strong>" +
        (this.deliveryType == "prepay"
          ? this.$t("userOrdersPayedFullSummary")
          : this.$t("userOrdersFullSummary")) +
        ": " +
        this.price(this.deliveryFinalSum) +
        "</strong></p>";

      if (
        Number(
          this.$store.state.storeClient.client.environmentSettings.taxTitle
        ) > 0
      )
        body +=
          "<p style='font-size: 70%; font-style: italic; margin: 0px'>" +
          this.$t("userOrdersIncludesTax") +
          " " +
          this.$store.state.storeClient.client.environmentSettings.taxTitle +
          ".</p>";

      return body;
    },
    generateNewOrderEmailBody() {
      let body = "";

      body +=
        "<p>" +
        (this.deliveryType == "prepay"
          ? this.$store.state.storeClient.client.responseSettings.newOrderPrepayMsg
              .split("[email]")
              .join(this.deliverySelected.email)
          : this.$store.state.storeClient.client.responseSettings.newOrderMsg) +
        "</p>";

      body +=
        "<h2>" +
        this.$t("userCashierOrderIdTitle") +
        ": " +
        this.$store.state.storeClientCounters.orderId +
        "</h2>";

      if (this.deliveryType == "prepay") {
        // PODATKI ZA PREDRAČUN
        body +=
          "<p style='padding: 5px 10px 5px 10px; max-width: 300px; font-weight: bold; background-color: red" +
          "; color: white;'>" +
          this.$t("userOrdersSendEmailPrepayHeaderTitle") +
          "</p>";
        body += "<p>";
        body += this.$store.state.storeClient.client.prepaySettings.prepayInfo
          .split("\n")
          .join("<br />");
        body += "</p>";

        body +=
          "<div>" +
          this.$t("userOrdersSendEmailReferenceSubject") +
          ": <strong>" +
          this.referenceId +
          "</strong><br />" +
          this.$t("userOrdersFullSummary") +
          ": <strong>" +
          this.price(this.deliveryFinalSum) +
          "</strong></div>";
      }

      // PODROBNOSTI NAROČILA
      body +=
        "<p style='padding: 5px 10px 5px 10px; max-width: 300px; font-weight: bold; background-color: " +
        this.$store.state.storeClient.client.visualSettings.themeColor
          .primaryColor +
        "; color: white;'>" +
        this.$t("userOrdersPackagesList") +
        "</p>";

      // MOD PHOTO ORDER DETAILS
      if (
        this.$store.state.storeCart.cart.filter(
          (x) => x.module == G_MODULE_PHOTO_ORDER
        ).length > 0
      ) {
        body +=
          "<p style='padding: 5px 10px 5px 10px; max-width: 300px; font-weight: regular; background-color: " +
          this.$store.state.storeClient.client.visualSettings.themeColor
            .secondaryColor +
          "; color: white;'>" +
          this.getModuleName(G_MODULE_PHOTO_ORDER) +
          " (" +
          this.$store.state.storeCart.modPhotoOrderSummary.totalCopies +
          ")" +
          "</p>";

        body += "<p>";
        Array.from(
          this.$store.state.storeCart.cart.filter(
            (x) => x.module == G_MODULE_PHOTO_ORDER
          )
        ).forEach((x) => {
          x.imageDataStr.forEach((y) => {
            body +=
              "<div style='margin-left: 10px;'>" +
              y.str +
              "<span style='margin-left: 6px;'><a href='" +
              x.url +
              "'>[DL]</a></span>" +
              "</div>";
          });
        });
        body += "</p>";
        body += "<p>";

        body +=
          "<div>" +
          this.$t("userNewOrderSummary2Title") +
          ": " +
          this.price(
            this.$store.state.storeCart.modPhotoOrderSummary.totalSumLabPrice
          ) +
          "</div>";

        if (
          this.$store.state.storeCart.modPhotoOrderSummary
            .totalSumQuantityDiscountPrice > 0
        ) {
          body +=
            "<div>" +
            this.$t("userNewOrderSummary3Title") +
            ": -" +
            this.price(
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumQuantityDiscountPrice
            ) +
            " (-" +
            this.percent(
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumQuantityDiscount
            ) +
            ")" +
            "</div>";
          body +=
            "<div>" +
            this.$t("userNewOrderSummary4Title") +
            ": " +
            this.price(
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumQuantityPrice
            ) +
            "</div>";
        }

        if (
          this.$store.state.storeCart.modPhotoOrderSummary.totalSumExtraCharge >
          this.$store.state.storeCart.modPhotoOrderSummary.totalSumQuantityPrice
        ) {
          body +=
            "<div>" +
            this.$store.state.storeClient.client.modules.modulePhotoOrder
              .extraChargeMessage +
            ": " +
            this.price(
              this.$store.state.storeClient.client.modules.modulePhotoOrder
                .extraCharge
            ) +
            "</div>";
          body +=
            "<div>" +
            this.$t("userNewOrderSummaryExtraChargeTitle") +
            ": " +
            this.price(
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumExtraCharge
            ) +
            "</div>";
        }

        if (
          this.$store.state.storeCart.modPhotoOrderSummary
            .totalSumPromoCodeDiscount > 0
        ) {
          body +=
            "<div>" +
            this.$t("userNewOrderSummary5Title") +
            ": " +
            this.price(
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumPromoCodeDiscount
            ) +
            " (-" +
            this.percent(this.$store.state.storeCart.activePromoCodeDiscount) +
            ")" +
            "</div>";
          body +=
            "<div>" +
            this.$t("userNewOrderSummary5cTitle") +
            ": " +
            this.price(
              this.$store.state.storeCart.modPhotoOrderSummary
                .totalSumPromoCodeDiscountPrice
            ) +
            "</div>";
        }

        body += "</p>";
      }

      // MOD PHOTO GIFT DETAILS
      if (
        this.$store.state.storeCart.cart.filter(
          (x) => x.module == G_MODULE_PHOTO_GIFT
        ).length > 0
      ) {
        body +=
          "<p style='padding: 5px 10px 5px 10px; max-width: 300px; font-weight: regular; background-color: " +
          this.$store.state.storeClient.client.visualSettings.themeColor
            .secondaryColor +
          "; color: white;'>" +
          this.getModuleName(G_MODULE_PHOTO_GIFT) +
          " (" +
          this.$store.state.storeCart.modPhotoGiftSummary.totalCopies +
          ")" +
          "</p>";

        body += "<p>";
        Array.from(
          this.$store.state.storeCart.cart.filter(
            (x) => x.module == G_MODULE_PHOTO_GIFT
          )
        ).forEach((x) => {
          body +=
            "<div style='margin-left: 10px;'>" +
            x.itemName +
            " | " +
            x.imageDataStr +
            "<span style='margin-left: 6px;'><a href='" +
            x.url +
            "'>[DL]</a></span>" +
            "</div>";
        });
        body += "</p><p>";

        body +=
          "<div>" +
          this.$t("userNewOrderSummary2Title") +
          ": " +
          this.price(
            this.$store.state.storeCart.modPhotoGiftSummary.totalSumLabPrice
          ) +
          "</div>";

        if (
          this.$store.state.storeCart.modPhotoGiftSummary.totalSumExtraCharge >
          this.$store.state.storeCart.modPhotoGiftSummary.totalSumLabPrice
        ) {
          body +=
            "<div>" +
            this.$store.state.storeClient.client.modules.modulePhotoGift
              .extraChargeMessage +
            ": " +
            this.price(
              this.$store.state.storeClient.client.modules.modulePhotoGift
                .extraCharge
            ) +
            "</div>";
          body +=
            "<div>" +
            this.$t("userNewOrderSummaryExtraChargeTitle") +
            ": " +
            this.price(
              this.$store.state.storeCart.modPhotoGiftSummary
                .totalSumExtraCharge
            ) +
            "</div>";
        }

        if (
          this.$store.state.storeCart.modPhotoGiftSummary
            .totalSumPromoCodeDiscount > 0
        ) {
          body +=
            "<div>" +
            this.$t("userNewOrderSummary5Title") +
            ": " +
            this.price(
              this.$store.state.storeCart.modPhotoGiftSummary
                .totalSumPromoCodeDiscount
            ) +
            " (-" +
            this.percent(this.$store.state.storeCart.activePromoCodeDiscount) +
            ")" +
            "</div>";
          body +=
            "<div>" +
            this.$t("userNewOrderSummary5cTitle") +
            ": " +
            this.price(
              this.$store.state.storeCart.modPhotoGiftSummary
                .totalSumPromoCodeDiscountPrice
            ) +
            "</div>";
        }

        body += "</p>";
      }

      body += "<p>";
      // PROMO KODE
      if (this.$store.state.storeCart.activePromoCodeActivated) {
        body +=
          "<div>" +
          this.$t("userNewOrderSummary5aTitle") +
          " <strong>" +
          this.$store.state.storeCart.activePromoCode.toUpperCase() +
          "</strong> / " +
          this.getModuleName(
            this.$store.state.storeCart.activePromoCodeModule
          ) +
          " (-" +
          this.percent(this.$store.state.storeCart.activePromoCodeDiscount) +
          ")" +
          "</div>";
        body +=
          "<div>" +
          this.$t("userNewOrderSummary5dTitle") +
          ": " +
          this.price(this.$store.state.storeCart.totalSumPromoCodeDiscount) +
          "</div>";
      }

      body += "</p>";
      body += "<p>";

      // ZNESEK NAROČILA
      body +=
        "<div>" +
        this.$t("userNewOrderSummary6Title") +
        ": " +
        this.price(this.$store.state.storeCart.totalSumCart) +
        "</div>";

      // LABORATORIJSKA OBDELAVA OZ POŠTNINA
      if (
        (this.deliveryName.length > 0 &&
          this.$store.state.storeCart.totalSumCart <
            this.deliverySelected.extraChargeFreeOver &&
          this.deliverySelected.extraCharge > 0) ||
        (this.deliveryName.length > 0 &&
          this.deliverySelected.extraChargeFreeOver == 0 &&
          this.deliverySelected.extraCharge > 0)
      ) {
        body +=
          "<div>" +
          this.deliverySelected.extraChargeMessage +
          ": " +
          this.price(this.deliverySelected.extraCharge) +
          "</div>";
      }
      // KONČNA CENA
      body +=
        "<div style='border-top: 1px dashed gray; margin-top:5px; padding-top: 5px; max-width: 300px;'><strong>" +
        this.$t("userOrdersFullSummary") +
        ": " +
        this.price(this.deliveryFinalSum) +
        "</strong></div>";
      body += "</p>";

      if (
        Number(
          this.$store.state.storeClient.client.environmentSettings.taxTitle
        ) > 0
      )
        body +=
          "<p style='font-size: 70%; font-style: italic; margin: 0px'>" +
          this.$t("userOrdersIncludesTax") +
          " " +
          this.$store.state.storeClient.client.environmentSettings.taxTitle +
          ".</p>";

      // DOSTAVA
      body +=
        "<p>" +
        this.$t("userCashierDeliveryTitle") +
        ": " +
        this.deliveryName +
        "<br />" +
        this.$t("userCashierDeliveryTypeTitle") +
        ": " +
        this.deliveryTypeItems.find((x) => x.type == this.deliveryType).title +
        "</p>";

      // OSEBNI PODATKI
      body +=
        "<p style='padding: 5px 10px 5px 10px; max-width: 300px; font-weight: bold; background-color: " +
        this.$store.state.storeClient.client.visualSettings.themeColor
          .primaryColor +
        "; color: white;'>" +
        (this.addressItem.isCompany
          ? this.$t("userSettingsCompanyInfoTitle")
          : this.$t("userSettingsPersonalInfoTitle")) +
        "</p>";

      if (this.addressItem.isCompany) body += "<p>";
      this.$t("userSettingsVatNumberTitle") +
        ": " +
        this.addressItem.vatNumber +
        "<br />";

      body +=
        (this.addressItem.isCompany
          ? this.$t("userSettingsCompanyFullNameTitle")
          : this.$t("userSettingsFullNameTitle")) +
        ": " +
        this.addressItem.fullName +
        "<br />" +
        (this.addressItem.isCompany
          ? this.$t("userSettingsCompanyAddress1Title")
          : this.$t("userSettingsAddress1Title")) +
        ": " +
        this.addressItem.address1 +
        "<br />" +
        this.$t("userSettingsAddress2Title") +
        ": " +
        this.addressItem.address2 +
        "<br />" +
        this.$t("userSettingsCountryTitle") +
        ": " +
        this.countryItems.find(
          (x) => x.cShort == this.$store.state.storeAuth.userProfile.country
        ).title +
        "<br />" +
        this.$t("userSettingsPhoneTitle") +
        ": " +
        this.addressItem.phone +
        "<br />" +
        this.$t("userSettingsEmailTitle") +
        ": " +
        this.addressItem.email;

      body += "</p>";

      if (this.messageForStudio.length > 0)
        body +=
          "<p>" +
          this.$t("userOrdersMessageForStudio") +
          ": " +
          this.messageForStudio +
          "</p>";

      return body;
    },
    generateNewOrderEmailBodyNotify(moduleName) {
      let body = "";
      body +=
        "<h2>" +
        this.$t("userCashierOrderIdTitle") +
        ": " +
        this.$store.state.storeClientCounters.orderId +
        "</h2>";

      // MOD PHOTO ORDER DETAILS
      if (
        this.$store.state.storeCart.cart.filter((x) => x.module == moduleName)
          .length > 0 &&
        moduleName == G_MODULE_PHOTO_ORDER
      ) {
        body +=
          "<p style='padding: 5px 10px 5px 10px; max-width: 300px; font-weight: regular; background-color: " +
          this.$store.state.storeClient.client.visualSettings.themeColor
            .secondaryColor +
          "; color: white;'>" +
          this.getModuleName(G_MODULE_PHOTO_ORDER) +
          " (" +
          this.$store.state.storeCart.modPhotoOrderSummary.totalCopies +
          ")" +
          "</p>";

        body += "<p>";
        Array.from(
          this.$store.state.storeCart.cart.filter(
            (x) => x.module == G_MODULE_PHOTO_ORDER
          )
        ).forEach((x) => {
          x.imageDataStr.forEach((y) => {
            body +=
              "<div style='margin-left: 10px;'>" +
              y.str +
              "<span style='margin-left: 6px;'><a href='" +
              x.url +
              "'>[DL]</a></span>" +
              "</div>";
          });
        });
        body += "</p>";
      }

      // MOD PHOTO GIFT DETAILS
      if (
        this.$store.state.storeCart.cart.filter((x) => x.module == moduleName)
          .length > 0 &&
        moduleName == G_MODULE_PHOTO_GIFT
      ) {
        body +=
          "<p style='padding: 5px 10px 5px 10px; max-width: 300px; font-weight: regular; background-color: " +
          this.$store.state.storeClient.client.visualSettings.themeColor
            .secondaryColor +
          "; color: white;'>" +
          this.getModuleName(G_MODULE_PHOTO_GIFT) +
          " (" +
          this.$store.state.storeCart.modPhotoGiftSummary.totalCopies +
          ")" +
          "</p>";

        body += "<p>";
        Array.from(
          this.$store.state.storeCart.cart.filter(
            (x) => x.module == G_MODULE_PHOTO_GIFT
          )
        ).forEach((x) => {
          body +=
            "<div style='margin-left: 10px;'>" +
            x.itemName +
            " | " +
            x.imageDataStr +
            "<span style='margin-left: 6px;'><a href='" +
            x.url +
            "'>[DL]</a></span>" +
            "</div>";
        });
        body += "</p>";
      }

      // DOSTAVA
      body +=
        "<p>" +
        this.$t("userCashierDeliveryTitle") +
        ": " +
        this.deliveryName +
        "<br />" +
        this.$t("userCashierDeliveryTypeTitle") +
        ": " +
        this.deliveryTypeItems.find((x) => x.type == this.deliveryType).title +
        "</p>";

      if (this.messageForStudio.length > 0)
        body +=
          "<p>" +
          this.$t("userOrdersMessageForStudio") +
          ": " +
          this.messageForStudio +
          "</p>";

      //console.log(moduleName);
      //console.log(body);
      return body;
    },
  },
  mounted() {
    this.deliveryFinalSum = this.$store.state.storeCart.totalSumCart;
  },
  created() {
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
    this.G_MODULE_ALL = G_MODULE_ALL;

    // ali manjka kakšen osebni podatek uporabnika?
    if (
      (this.addressItem.isCompany && this.addressItem.vatNumber.length < 2) ||
      this.addressItem.country.length < 2 ||
      this.addressItem.address2.length < 2 ||
      this.addressItem.address1.length < 2 ||
      this.addressItem.fullName.length < 2 ||
      this.addressItem.phone.length < 2 ||
      this.addressItem.email.length < 2
    ) {
      this.addUserInfo = true;
    } else this.addUserInfo = false;
  },
};
</script>